import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { has as _has } from 'lodash-es';
import { Observable, Subject } from 'rxjs';
import { map, retry, shareReplay, takeUntil } from 'rxjs/operators';

import { TargetChallengeDataResponse } from '../../shared/models/target-challenge-data-response';

const API_ENDPOINT = '/api/targetchallenge/';

@Injectable({
  providedIn: 'root',
})
export class SkillService {

  private skills: Observable<TargetChallengeDataResponse[]>[];
  private reload = new Subject<void>();

  /**
   * Constructor
   *
   * @param http HttpClient
   */
  public constructor(private http: HttpClient) {
    this.skills = [];
  }

  /**
   * Gets the TargetChallengeData items.
   *
   * @param {string} type
   *
   * @returns {Observable<TargetChallengeDataResponse>}
   */
  public getDataItemsForType(type: string): Observable<TargetChallengeDataResponse> {
    if (!_has(this.skills, type)) {
      this.skills[type] = this.loadDataForType(type).pipe(
        shareReplay(1),
        takeUntil(this.reload),
      );
    }

    return this.skills[type];
  }

  /**
   * Loads the required TargetChallengeData for the given type
   *
   * @returns Observable<TargetChallengeDataResponse>
   */
  public loadDataForType(type: string): Observable<TargetChallengeDataResponse> {
    return this.http.get(API_ENDPOINT + 'get/data/' + type)
    .pipe(
      retry(3),
      map(
        (response: { error: string, items: TargetChallengeDataResponse }) => {
          return response.items;
        },
      ),
    );
  }

  /**
   * Force the active player to refresh
   * @return void
   */
  public forceReload(): void {
    this.reload.next();
    this.skills = [];
  }
}
